import { createContext } from "react";

import AppsFlyer from "../lib/AppsFlyerAdapter";

export const AppsFlyerContext = createContext<AppsFlyer>(AppsFlyer.getInstance());
